<template>
  <div class="header">
    <div class="nav" :style="{height:isPositionTop ? '0' :'18vw'}">
      <img src="https://summit-img.geekpark.net/r2020/rebuild2020.svg" style="width: 50vw" />
      <img
        src="https://summit-img.geekpark.net/mobile/01-%E5%AF%BC%E8%88%AA-%E5%85%B3%E9%97%AD.svg"
        style="width: 8vw"
        v-show="!hideNavs"
        @click="toggleNavsVisible"
      />
      <img
        src="https://summit-img.geekpark.net/mobile/01-%E5%AF%BC%E8%88%AA-%E8%8F%9C%E5%8D%95.svg"
        style="width: 8vw"
        v-show="hideNavs"
        @click="toggleNavsVisible"
      />
      <ul class="navs" v-show="!hideNavs">
        <li v-for="(item,index) in navs" :key="index">
          <a href @click.prevent="scrollToPosition(item.position)">
            <img :src="item.name" :style="item.style" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      isPositionTop: true,
      hideNavs: true,
      navs: [
        // {
        //   name: "https://summit-img.geekpark.net/r2020/nav_guest.svg",
        //   position: "#guest"
        // },
        {
          name: "https://summit-img.geekpark.net/r2020/nav_date.svg",
          position: "#datePlan"
        },
        {
          name: "https://summit-img.geekpark.net/r2020/nav_last.svg",
          position: "#last_years"
        },
        {
          name: "https://summit-img.geekpark.net/r2020/nav_concat.svg",
          position: "#contcat"
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleNavState);
  },
  methods: {
    getElementTop(element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }

      return actualTop;
    },
    handleNavState(e) {
      this.hideNavs = true;
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollHeight > 0) {
        this.isPositionTop = false;
      } else {
        this.isPositionTop = true;
      }
    },
    toggleNavsVisible() {
      this.hideNavs = !this.hideNavs;
    },
    scrollToPosition(id) {
      if (id.startsWith("#")) {
        const navsHeight = document.querySelector(".nav").offsetHeight;
        const position = this.getElementTop(document.querySelector(id));
        window.scrollTo({
          top: position - navsHeight,
          behavior: "smooth"
        });
      } else {
        window.open(id, "blank");
      }
      return false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleNavState);
  }
};
</script>

<style scoped lang="less">
.header {
  position: relative;
}

.nav {
  box-sizing: border-box;
  position: fixed;
  width: 100vw;
  left: 0;
  top: 0;
  padding: 0 5vw;
  display: flex;
  justify-content: space-between;
  background: #0023fc;
  text-align: left;
  z-index: 100;
  transition: height 0.3s;
}

ul.navs {
  position: absolute;
  top: 100%;
  width: 100%;
  left: 0;
  padding: 7vw 0;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  background-color: #5becd0;
  transition: opacity 0.3s linear;

  li {
    height: 12vw;
    list-style: none;
    height: 12vw;
    list-style: none;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #1d1d1d;
      text-decoration: none;
      text-align: center;
      letter-spacing: 0.5vw;
      font-size: 4.2vw;
      width: 64vw;
      border: 1px solid #000;
      background: #fff;
      &:active {
        background: #fcf351;
      }
      img {
        width: 30vw;
      }
    }
  }
}
</style>
